import React from 'react';
import Reveal from '../components/Reveal';

const TEAM = [
  {
    handle: 'jonas',
    name: 'Jonas Pauli',
    role: 'CEO · Research & engineering',
    image: '/jonas-profile.jpeg',
    lane: 'Research & engineering',
    tagline: 'CEO',
    description:
      'Applied cryptography engineer with deep expertise in zero-knowledge proofs, distributed systems and microservice architecture for long-running, critical systems.',
    bookingLabel: 'Book a 30min call',
    bookingHref: 'https://cal.com/jonas-p-oswsyh/30min',
    links: [
      { label: 'github', href: 'https://github.com/jonas089' },
      { label: 'linkedin', href: 'https://www.linkedin.com/in/jonas-pauli/' },
    ],
  },
  {
    handle: 'kristiana',
    name: 'Kristiana Skrastina',
    role: 'Marketing Manager · Brand & marketing',
    image: '/Kristiana.png',
    lane: 'Brand & marketing',
    tagline: 'Marketing Manager',
    description:
      'Responsible for Design decisions, Brand identity, communication strategy and outreach.',
    bookingLabel: null,
    bookingHref: null,
    links: [
      { label: 'linkedin', href: 'https://www.linkedin.com/in/kristiana-skrastina/' },
    ],
  },
];

const Member = ({ name, image, lane, tagline, description, bookingLabel, bookingHref, links }) => (
  <article className="member">
    <div className="member-portrait">
      <img src={image} alt={name} />
    </div>

    <div style={{ minWidth: 0 }}>
      <h2
        className="font-display"
        style={{
          fontSize: 'clamp(26px, 2.6vw, 36px)',
          fontWeight: 600,
          letterSpacing: '-0.035em',
          margin: 0,
          color: 'var(--ink)',
          lineHeight: 1.05,
        }}
      >
        {name}
      </h2>
      <p className="member-role">{tagline} · {lane}</p>

      <p className="prose prose-sm" style={{ margin: '18px 0 0' }}>
        {description}
      </p>

      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 24, marginTop: 24 }}>
        {bookingHref ? (
          <a
            href={bookingHref}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            style={{ fontSize: 14, padding: '10px 18px' }}
          >
            {bookingLabel} →
          </a>
        ) : bookingLabel ? (
          <span style={{ fontSize: 14, color: 'var(--ink-3)' }}>{bookingLabel}</span>
        ) : null}

        {links.map((l) => (
          <a
            key={l.label}
            href={l.href}
            target="_blank"
            rel="noopener noreferrer"
            className="link-quiet"
            style={{ fontSize: 15 }}
          >
            {l.label} →
          </a>
        ))}
      </div>
    </div>
  </article>
);

const Services = () => (
  <div>
    <section style={{ paddingTop: 'clamp(48px, 7vh, 96px)', paddingBottom: 'clamp(24px, 4vh, 48px)', position: 'relative', overflow: 'hidden' }}>
      <div className="hero-blur" style={{ left: '-220px', top: '-80px', opacity: 0.7 }} />
      <div className="page" style={{ position: 'relative' }}>
        <Reveal delay={0.05}>
          <h1
            className="font-display"
            style={{
              fontSize: 'clamp(44px, min(8vw, 11vh), 128px)',
              fontWeight: 600,
              fontFamily: "'Geist', system-ui, sans-serif",
              letterSpacing: '-0.045em',
              margin: 0,
              color: 'var(--ink)',
              maxWidth: '14ch',
              lineHeight: 0.96,
            }}
          >
            Team.
          </h1>
        </Reveal>
      </div>
    </section>

    <section style={{ paddingBottom: 'clamp(56px, 8vh, 96px)' }}>
      <div className="page">
        <div className="member-list">
          {TEAM.map((person, i) => (
            <Reveal key={person.handle} delay={i * 0.06}>
              <Member {...person} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default Services;
